import { getEditorPlugin,type SlateEditor } from '@udecode/plate';

import { LinkPlugin } from '../LinkPlugin';
import { triggerFloatingLinkEdit } from './triggerFloatingLinkEdit';
import { triggerFloatingLinkInsert } from './triggerFloatingLinkInsert';

export const triggerFloatingLink = (
    editor: SlateEditor,
    {
        focused,
    }: {
    focused?: boolean;
  } = {}
) => {
    const { getOptions } = getEditorPlugin(editor, LinkPlugin);

    if (getOptions().mode === 'edit') {
        triggerFloatingLinkEdit(editor);

        return;
    }

    triggerFloatingLinkInsert(editor, {
        focused,
    });
};
